import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navItems = [{
  name: 'About',
  href: '#about'
}, {
  name: 'Expertise',
  href: '#expertise'
}, {
  name: 'Achievements',
  href: '#achievements'
}, {
  name: 'Experience',
  href: '#experience'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-xl shadow-lg shadow-gray-200/50 py-4 border-b border-gray-200/50' : 'bg-gradient-to-b from-black/30 to-transparent backdrop-blur-sm py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-166" data-mp="dh0sunetvmh9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167" data-mp="webf97fd2lfa">
        <div className="flex justify-between items-center" data-id="element-168" data-mp="10fdjk2o4xno4">
          <a href="#hero" onClick={e => scrollToSection(e, '#hero')} className={`text-xl font-bold tracking-tight transition-all duration-300 ${isScrolled ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#1e3a8a] via-gray-600 to-[#1e3a8a]' : 'text-white drop-shadow-lg'}`} data-id="element-169" data-mp="156vhsiyrxa5e">
            Albert Previte
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-170" data-mp="ufqvxuidzysq">
            {navItems.map(item => <a key={item.name} href={item.href} onClick={e => scrollToSection(e, item.href)} className={`text-sm font-medium transition-all duration-300 ${isScrolled ? 'text-gray-700 hover:text-[#1e3a8a]' : 'text-gray-100 hover:text-white drop-shadow-md'}`} data-id="element-171" data-mp="pgxiu370i9t3">
                {item.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-172" data-mp="186vo6bjfdot1">
            {isMobileMenuOpen ? <X className={isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'} data-id="element-173" data-mp="1i6crimb7fqlu" /> : <Menu className={isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'} data-id="element-174" data-mp="3jxzm0xub23n2" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white/95 backdrop-blur-xl border-t border-gray-200/50" data-id="element-175" data-mp="1ppdqqvez2y3e">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-176" data-mp="1knwpgyskt9ma">
            {navItems.map(item => <a key={item.name} href={item.href} onClick={e => scrollToSection(e, item.href)} className="block px-3 py-4 text-base font-medium text-gray-700 hover:text-[#1e3a8a] hover:bg-gray-50 rounded-md" data-id="element-177" data-mp="16sch2xah49t4">
                {item.name}
              </a>)}
          </div>
        </motion.div>}
    </motion.header>;
}